import { OrganizationState } from "@grudder/types/organization.types";
import { createSlice } from "@reduxjs/toolkit";
import { fetchUserOrganizations } from "./organization.thunk";

const initialState: OrganizationState = {
  organizations: {
    data: [],
    loading: false,
    error: null,
  },
  activeOrganization: {
    data: null,
    users: [],
    loading: false,
    error: null,
  },
};

const organizationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    setOrganizations: (state, action) => {
      state.organizations.data = action.payload;
    },
    setActiveOrganization: (state, action) => {
      state.activeOrganization.data = action.payload;
    },
    setActiveOrganizationUsers: (state, action) => {
      state.activeOrganization.users = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserOrganizations.pending, (state) => {
        state.organizations.loading = true;
      })
      .addCase(fetchUserOrganizations.fulfilled, (state, action) => {
        state.organizations.loading = false;
        state.organizations.data = action.payload;
      })
      .addCase(fetchUserOrganizations.rejected, (state, action) => {
        state.organizations.loading = false;
        if (action.error.message) {
          state.organizations.error = action.error.message;
        }
      });
  },
});

export const { setOrganizations, setActiveOrganization, setActiveOrganizationUsers } = organizationSlice.actions;
export default organizationSlice.reducer;
